import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currency_list: [],
    active_currency: null
  };
  
  const changeCurrencyStateSlice = createSlice({
    name: 'currency',
    initialState: initialState,
    reducers: {
      listCurrency: (state, action) => {
        state.currency_list= action.payload 
      },
     
      activeCurrency: (state) => {
       
      }
    }
  });
  
  export const { listCurrency, activeCurrency } = changeCurrencyStateSlice.actions;
  
  export default changeCurrencyStateSlice.reducer;